'use strict'

import React from 'react';

import OrdinaryField from './Field3.jsx';

export default class MultiTable extends React.Component {
  addEntry(details) {
    if (this.props.addEntry!==undefined && this.props.addEntry.handler!==undefined) {
      this.props.addEntry.handler(Object.assign({},details,{type:this.props.type}))
    }
  }

  editEntry(details) {
    if (this.props.onEditEntry!==undefined) {
      this.props.onEditEntry(Object.assign({},details,{type:this.props.type}))
    }
  }

  render() {
    return (
      <div style={{width: "100%"}}>
        {this.props.value!==undefined && this.props.value.length>0 ? (
          this.props.value.map(item=>
            <div key={item.id} style={{border:item._displayAs==="_highlight" ? (item.simulated===true ? "dashed" : "solid")+" 2px #8BC34A" : item._displayAs==="_normal" ? "solid 2px orange" : undefined, marginBottom:3}}>
              <OrdinaryField
                {...this.props}
                value={item.items}
                showFlag={item._displayAs==="_normal"}
                title={item.text}
                help={item.description}
                name={this.props.name+"."+item.id}
                _hideColumnHeader={item._hideColumnHeader}
                _disableOption={item._disableOption}
                type="table"
                addEntry={Object.assign({},this.props.addEntry,{handler: this.addEntry.bind(this)})}
                onEditEntry={this.editEntry.bind(this)}
              />
            </div>
          )
        ) : <i>{this.props.empty!==undefined && this.props.empty.message ? this.props.empty.message : ".(empty.message)"}</i> }
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./views/components/MultiTable.jsx